import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Loader, Text, Modal, ContentBlock } from '@simplybenefits/sb-ui-library';
import PendingChangesTable from './PendingChangesTable.js';
import { getPendingChanges, removePendingChange } from '../../../actions/accounts.js';

class PendingChanges extends PureComponent {
    state = {
        changes: null,
        changeToDelete: null
    };

    componentDidMount() {
        this._getChanges(this.props.accountID);
    }

    _getChanges = async () => {
        const changes = await this.props.dispatch(getPendingChanges(this.props.accountID));

        this.setState({
            changes: changes || [],
            changeToDelete: null
        });
    };

    _removeChange = async (changeID) => {
        if (changeID) {
            this.setState({
                changeToDelete: changeID
            });

            return;
        }

        const success = await this.props.dispatch(removePendingChange(this.state.changeToDelete, this.props.accountID));

        if (success) {
            this._getChanges();
        }
    };

    render() {

        if (!this.state.changes) {
            return <Loader isContainer/>;
        }

        return (
            <ContentBlock>
                <Text extraLarge bold>Pending Changes</Text>

                <div style={{ marginTop: 30 }}>
                    {
                        this.state.changes.length === 0 ?
                            <Text large light>No Records</Text>
                            :
                            <PendingChangesTable records={ this.state.changes } removeChange={ this._removeChange } accountID={ this.props.accountID } />
                    }

                    <Modal
                        open={this.state.changeToDelete !== null}
                        onClose={() => this.setState({ changeToDelete: null })}
                        title="Are you sure?"
                        primaryButton={{
                            label: "Remove Change",
                            onClick: () => this._removeChange(false)
                        }}
                        loader={this.props.loader}
                    >
                        <Text medium margin="10px 0 0 0">
                            By clicking the button below, this scheduled change will not take effect.
                        </Text>
                    </Modal>

                </div>
            </ContentBlock>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader
});

export default (connect(mapStateToProps)(PendingChanges));